import { render, staticRenderFns } from "./StoreButtonsBox.vue?vue&type=template&id=2354f7d1&scoped=true"
import script from "./StoreButtonsBox.vue?vue&type=script&lang=js"
export * from "./StoreButtonsBox.vue?vue&type=script&lang=js"
import style0 from "./StoreButtonsBox.vue?vue&type=style&index=0&id=2354f7d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354f7d1",
  null
  
)

export default component.exports